import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { Resource } from '@opentelemetry/resources';

const exporter = new OTLPTraceExporter({
  url: import.meta.env.VITE_APP_COLETOR_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});
const provider = new WebTracerProvider({
  resource: new Resource({
    'service.name': import.meta.env.VITE_APP_APPLICATION_NAME,
    application: 'ControleTecnologico.Vue'
  }),
  spanProcessors: [new BatchSpanProcessor(exporter)]
});

if (import.meta.env.MODE !== 'development') {
  //provider.addSpanProcessor(new BatchSpanProcessor(new ConsoleSpanExporter()));

  provider.register();

  // Registering instrumentations / plugins
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        // load custom configuration for xml-http-request instrumentation
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: [
            /\/api\//g //Regex to match your backend urls. This should be updated.
          ],
          ignoreUrls: [/\/chathub\//g],
          enabled: true
        },
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: [
            /\/api\//g //Regex to match your backend urls. This should be updated.
          ],

          enabled: false
        },
        '@opentelemetry/instrumentation-document-load': {
          enabled: false
        },
        '@opentelemetry/instrumentation-user-interaction': {
          enabled: false
        }
      })
    ]
  });
}
